import { Box, Text, Price } from "flicket-ui";
import { useOrganization } from "~hooks";
import pluralize from "pluralize";
import { ScheduleOption } from "~graphql/sdk";

export const PaymentPlanBadge = ({
  scheduleOptions,
}: {
  scheduleOptions: ScheduleOption[];
}) => {
  const { organization } = useOrganization();

  const safeScheduleOptions = Array.isArray(scheduleOptions) ? scheduleOptions : [];
  const maxInstallmentCount = safeScheduleOptions.length > 0
    ? safeScheduleOptions.map((s) => s?.installmentCount ?? 0).reduce((a, b) => Math.max(a, b), 0)
    : 0;
  const minimumOrderAmount = safeScheduleOptions.length > 0
    ? safeScheduleOptions.map((s) => s?.minimumOrderAmount ?? Infinity).reduce((a, b) => Math.min(a, b), Infinity)
    : 0;

  return (
    <Box textAlign={"left"} w={"100%"} borderRadius="md" borderWidth="1px" borderColor="N200" borderStyle="solid" p={2}>
      <Text variant="regular" fontWeight="bold">Payment plans available</Text>
      <Text variant="small">
        Pay over {pluralize("month", maxInstallmentCount, true)}.
        {minimumOrderAmount > 0 ? <> Minimum <Price price={minimumOrderAmount} currency={organization.currency} />. </> : ' '}
        Available at checkout.
      </Text>
    </Box>
  );
};
